<nb-card class="transfer-documents-panel">
	<nb-card-body>
		<div class="card-header-wrapper">
			<h5 id="card-header" class="row-wrapper" [ngClass]="{'collapsed': !detailsVisible}">
				{{ 'transfer-documents.title-collapsed' | translate }}
			</h5>
			<a class="toggle-details-section" (click)="detailsVisible = !detailsVisible">
				{{ (detailsVisible ? 'common.hide' : 'common.show') | translate }}
				<nb-icon icon="{{detailsVisible ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'}}"></nb-icon>
			</a>
		</div>
		@if (detailsVisible) {
			<h6 id="transfer-documents">{{ 'transfer-documents.title' | translate }}</h6>
			<div class="document-group">
				<transfer-documents-group-info [blockInputs]="blockInputs" [groupTitle]="'transfer-documents.subtitle-certificate' | translate" [fileDetails]="certificateDocuments"
											   (onFileDownload)="onCertificateDownload($event)" [changed]="certificateDocumentsWereChanged()"></transfer-documents-group-info>
			</div>
			<div class="document-group">
				<transfer-documents-group-info [blockInputs]="blockInputs" [groupTitle]="'transfer-documents.subtitle-reports' | translate" [fileDetails]="reportDocuments"
											   (onFileDownload)="onReportDownload($event)" [changed]="reportDocumentsWereChanged()"></transfer-documents-group-info>
			</div>
		}
	</nb-card-body>
</nb-card>
